import AppConst from "../AppConst.ts";
import AtsJT from "./AtsJT.js";

export default class Cookie {
    constructor() {
        this.id = "";
        this.lifeSpan = 0;
        this.readOverJs = 0;
        this.domain = AppConst.cookieDomain;
        this.secure = AppConst.cookieSecure;
        this.sameSite = AppConst.cookieSameSite;
        this.path = AppConst.cookiePath;
        this.valuesMap = {};
    }

    toJson() {
        return JSON.stringify(this);
    }

    static fromJson(jsonStr) {
        try {
            const obj = JSON.parse(jsonStr);
            const cookieDto = new Cookie();

            cookieDto.id = obj.id || "";
            cookieDto.lifeSpan = obj.lifeSpan || 0;
            cookieDto.readOverJs = obj.readOverJs || 0;
            cookieDto.domain = obj.domain || AppConst.cookieDomain;
            cookieDto.secure = obj.secure || AppConst.cookieSecure;
            cookieDto.sameSite = obj.sameSite || AppConst.cookieSameSite;
            cookieDto.path = obj.path || AppConst.cookiePath;
            cookieDto.valuesMap = obj.valuesMap || {};

            return cookieDto;
        } catch (err) {
            console.error("Failed to parse JSON for CookieDto:", err);
            return null;
        }
    }

    static setCookie(id, cookieValue, lifeSpan = 86400) {
        const expires = new Date(Date.now() + lifeSpan * 1000).toUTCString();
        const base64Value = btoa(cookieValue);

        let cookieStr =
            id +
            "=" +
            base64Value +
            "; expires=" +
            expires +
            "; path=" +
            AppConst.cookiePath;
        cookieStr += "; domain=" + AppConst.cookieDomain;
        cookieStr += "; secure";
        cookieStr += "; SameSite=" + AppConst.cookieSameSite;
        document.cookie = cookieStr;
    }

    static deleteCookie(name) {
        if (!name) return;

        let cookieStr = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;

        if (AppConst.cookieDomain) {
            cookieStr += `;domain=${AppConst.cookieDomain}`;
        }
        if (AppConst.cookieSecure) {
            cookieStr += `;secure`;
        }
        if (AppConst.cookieSameSite) {
            cookieStr += `;SameSite=${AppConst.cookieSameSite}`;
        }

        document.cookie = cookieStr;
    }

    static readCookie(name) {
        const base64Value = Cookie.getCookieValue(name);
        return Cookie.base64ToUtf8(base64Value);
    }

    static getCookieValue(name) {
        const rawCookie = document.cookie
            .split("; ")
            .find((c) => c.startsWith(name + "="));
        if (!rawCookie) return null;
        return rawCookie.split("=")[1];
    }

    static base64ToUtf8(base64) {
        const binary = atob(base64);
        const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    }
}
